<template>
    <div class="wui-container lifestyle-detail">
        <Swiper
            type="lifestyle"
            :video="info.video"
            :cover="info.cover"
            :imgs="info.imgs"
            :height="555"
        ></Swiper>
        <User :user="info.user"></User>

        <div class="detail">
            <div class="desc" v-html="info.content"></div>
            <div class="tag-preview">
                <!-- <div class="tag">
                    <div class="tag-item" v-for="(item, index) in info.tags" :key="index">
                        <span>{{item}}</span>
                    </div>
                </div> -->
                <div class="location" v-if="info.location">
                    <span class="iconfont icon-Map"></span>
                    <span class="location">{{ info.location }}</span>
                </div>

                <div class="preview">
                    <span class="iconfont icon-View"></span>
                    <span class="preview">{{ info.views_num }}</span>
                </div>
            </div>
        </div>

        <CommentList :id="id" type="1" :userId="info.user_id"></CommentList>

        <div class="footer-fixed">
            <div
                class="input"
                @click="$downloadApp('subjectDetail', { subjectId: id })"
            >
                <div class="box">
                    {{ $t("发表你的天才演讲") }}
                </div>
            </div>
            <div
                class="btn-collect"
                @click="$downloadApp('subjectDetail', { subjectId: id })"
            >
                <span class="iconfont icon-1xin"></span>
                <span class="number">{{ info.collect_num }}</span>
            </div>
            <div class="btn-comment">
                <span class="iconfont icon-messageNumber"></span>
                <span class="number">{{ info.comment_num }}</span>
            </div>
        </div>

        <HomeButton bottom="80px"></HomeButton>
    </div>
</template>

<script>
import { useRoute } from "vue-router";

import api from "@/api/index";
import User from "@/components/User.vue";
import Swiper from "@/components/Swiper.vue";
import CommentList from "@/components/CommentList.vue";
import HomeButton from "@/components/HomeButton.vue";
import { initWechatJSSDK } from "@/assets/wechat.js";

export default {
    components: {
        User,
        Swiper,
        CommentList,
        HomeButton,
    },
    data() {
        return {
            id: "",
            info: {},
        };
    },
    mounted() {
        this.getLifestyleInfo();
        window.scrollTo(0, 0);
    },
    methods: {
        tagMatch(s) {
            var reg = /#.*? |#.*/g;
            s = s.match(reg);
            return s;
        },
        getLifestyleInfo() {
            const route = useRoute();
            this.id = route.params.id;
            api.lifestyle
                .getInfo({
                    ...this.util.getUrlSearch(),
                    version: 2,
                    id: route.params.id,
                })
                .then((res) => {
                    let tagArr = this.tagMatch(res.data.content) || [];
                    tagArr.forEach((item) => {
                        res.data.content = res.data.content.replace(
                            item,
                            `<a class='tag' href='/lifestyle/tag?tag=${encodeURIComponent(
                                item.replace("#", "").trim()
                            )}'>${item}</a>`
                        );
                    });
                    console.log(111);

                    this.info = res.data;

                    document.title = `${this.info.title}-${this.info.location}`;
                    initWechatJSSDK({
                        title: this.info.title,
                        desc: this.info.content,
                        imgUrl: this.info.cover.cover,
                    });
                });
        },
    },
    setup() {},
};
</script>

<style>
.lifestyle-detail {
    padding-bottom: 79px;
}
.detail {
    background-color: #ffffff;
    margin-bottom: 10px;
    padding: 15px;
    border-radius: 15px;
}
.detail .location {
    display: flex;
    align-items: center;
    height: 20px;
    font-size: 12px;
    color: #111111;
}
.detail .location .iconfont {
    margin-right: 4px;
    font-size: 14px;
    color: #111111;
}
.detail .preview {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #666666;
}
.detail .preview .iconfont {
    margin-right: 4px;
    font-size: 13px;
}
.detail .desc {
    font-size: 14px;
    color: #000000;
    line-height: 24px;
    white-space: pre-wrap;
    text-align: left;
}
.detail .desc a {
    display: inline;
    color: #2db6b5;
    /* text-decoration: underline; */
}
.detail .tag-preview {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
}
.detail .tag {
    flex: 1;
    display: flex;
    margin-top: 10px;
}
.detail .tag .tag-item {
    display: inline-flex;
    padding: 0 7px;
    border: 1px solid rgba(17, 17, 17, 0.03);
    border-radius: 6px;
    height: 23px;
    align-items: center;
    font-size: 12px;
    color: #666666;
    margin-right: 10px;
    margin-bottom: 10px;
}

.footer-fixed {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 12px 0;
    background-color: #ffffff;
    z-index: 1000;
    border-top: 1px solid #f8f8f8;
    display: flex;
    max-width: 500px;
    margin: 0 auto;
}
.footer-fixed .input {
    padding: 0 15px;
    flex: 1;
}
.footer-fixed .input .box {
    display: flex;
    align-items: center;
    background: #f8f8f8;
    border-radius: 6px;
    height: 44px;
    padding-left: 12px;
    font-size: 14px;
    color: #666666;
}
.footer-fixed .btn-collect,
.footer-fixed .btn-comment {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 42px;
    height: 44px;
}
.footer-fixed .btn-collect .number,
.footer-fixed .btn-comment .number {
    font-size: 12px;
    line-height: 17px;
    color: #111111;
}
.footer-fixed .btn-collect .iconfont {
    font-size: 20px;
    line-height: 18px;
    margin-bottom: 2px;
    color: #111111;
}
.footer-fixed .btn-collect .icon-CollectFill {
    color: #2db6b4;
}
.footer-fixed .btn-comment .iconfont {
    font-size: 18px;
    line-height: 18px;
    margin-bottom: 2px;
    color: #111111;
}
</style>
